module.exports = __webpack_public_path__ + "media/images/landing/en/save_time@2x-eba89e9e5040f5f6d27ddd471da1db68.png";